import { EntityListSkuInputData } from '../entityListTypes';
import { EntityListItemConverter } from './EntityListItemConverter';
import { ImportedItemRow } from '../../../../../lib/imports/importTypes';

/**
 * Converts data containing store and product information to/from a structured format.
 */
export class EntityListSkuItemConverter extends EntityListItemConverter<EntityListSkuInputData> {
  convertFromStrings(cells: string[]): Partial<EntityListSkuInputData> {
    const result: Partial<EntityListSkuInputData> = {};

    cells.forEach((cell, index) => {
      switch (index) {
        case 0:
          result.product = cell;
          break;
        case 1:
          result.store = cell;
          break;
      }
    });

    return result;
  }

  convertToStructuredText(data: ImportedItemRow<EntityListSkuInputData>[]): string {
    const validParsedRowsFlat = data
      .map(row => `${row.inputData.product},${row.inputData.store}`)
      .join('\n');
    return `ProductIdentification,StoreIdentification\n${validParsedRowsFlat}`;
  }
}
